import React from "react";
import PropTypes from "prop-types";
import ConnectedRoleCard from "./ConnectedRoleCard";
import IndividualRoleCardTitle from "./RoleCardTitle/IndividualRoleCardTitle";

const IndividualRoleCard = ({ description = "", ...props }) => {
    const renderTitle = (title) => (
        <IndividualRoleCardTitle description={description} title={title} />
    );
    const roleCardProps = {
        ...props,
        renderTitle,
    };
    return <ConnectedRoleCard {...roleCardProps} />;
};

IndividualRoleCard.propTypes = {
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default IndividualRoleCard;
